export default __webpack_public_path__ + "static/media/Office_Spaces_and_serviced_offices.aa32e64c.jpg";